import { render, staticRenderFns } from "./KitSkinsDialog.vue?vue&type=template&id=3d170ca7&scoped=true&"
import script from "./KitSkinsDialog.vue?vue&type=script&lang=ts&"
export * from "./KitSkinsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d170ca7",
  null
  
)

export default component.exports